import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsPageType } from '@icms/core/content/page/icms-page-type.decorator';
import { PageViewAbstract } from '../../../../catalog/ui/page/page-view.abstract';
import { CMS_BLOG_ROOT_CONFIG } from '../cms-blog-root.config';

@Component({
    selector: 'cms-blog-root-view',
    templateUrl: './cms-blog-root-view.component.html',
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsPageType(CMS_BLOG_ROOT_CONFIG)
export class CmsBlogRootViewComponent extends PageViewAbstract {}
